import Button from "components/Button";
import { FormEvent, useCallback, useEffect, useState } from "react";
import { ITenantConfig, changeTenantConfig } from "services/TenantServices";
import { fireToast } from "services/sweetAlertConfig";
import { InputStyled, PaymentForm } from "./styles";

export default function PaymentTab() {
  const [
    maximumKilometerBeforeAdditionaKmValues,
    setMaximumKilometerBeforeAdditionaKmValues,
  ] = useState<number>(0);

  const [
    maximumHoursBeforeAdditionaHourValues,
    setMaximumHoursBeforeAdditionaHourValues,
  ] = useState<number>(0);

  const handleSubmit = useCallback(
    async (event: FormEvent) => {
      event.preventDefault();
      const userConfig = JSON.parse(localStorage.getItem("user") ?? "");

      if (userConfig) {
        const currentConfig = userConfig.tenant.config as ITenantConfig;
        const newConfig: ITenantConfig = {
          ...currentConfig,
          maximumHoursBeforeAdditionaHourValues,
          maximumKilometerBeforeAdditionaKmValues,
        };
        try {
          await changeTenantConfig(newConfig);
        } catch {
          fireToast("Ocorreu um erro durante a troca das cores");
        } finally {
          window.location.reload();
        }
      }
    },
    [
      maximumKilometerBeforeAdditionaKmValues,
      maximumHoursBeforeAdditionaHourValues,
    ]
  );

  useEffect(() => {
    const userConfig = JSON.parse(localStorage.getItem("config") ?? "");

    if (userConfig) {
      const {
        maximumHoursBeforeAdditionaHourValues,
        maximumKilometerBeforeAdditionaKmValues,
      } = userConfig as ITenantConfig;

      console.log({
        maximumHoursBeforeAdditionaHourValues,
        maximumKilometerBeforeAdditionaKmValues,
      });

      if (maximumHoursBeforeAdditionaHourValues) {
        setMaximumHoursBeforeAdditionaHourValues(
          maximumHoursBeforeAdditionaHourValues
        );
      }

      if (maximumKilometerBeforeAdditionaKmValues) {
        setMaximumKilometerBeforeAdditionaKmValues(
          maximumKilometerBeforeAdditionaKmValues
        );
      }
    }
  }, []);

  return (
    <PaymentForm onSubmit={handleSubmit}>
      <InputStyled
        type="number"
        id="maximum_hours"
        name="maximum_hours"
        label="Cobrar horas adicionais a partir de quantas horas?"
        value={String(maximumHoursBeforeAdditionaHourValues)}
        required={false}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setMaximumHoursBeforeAdditionaHourValues(Number(event.target.value));
        }}
      />
      <InputStyled
        type="number"
        id="maximum_km"
        name="maximum_km"
        label="Cobrar quilometros adicionais a partir de quantos km?"
        value={String(maximumKilometerBeforeAdditionaKmValues)}
        required={false}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setMaximumKilometerBeforeAdditionaKmValues(
            Number(event.target.value)
          );
        }}
      />
      <Button title="Salvar" type="submit" />
    </PaymentForm>
  );
}
